import inquiry from "@/api/inquiry";

export default {
  state: {},
  mutations: {},
  actions: {
    async sendInquiry(context, { comment }) {
      try {
        let params = {
          account_id: await context.dispatch("showAccountID"),
          user_id: await context.dispatch("showUserId"),
          user_name: await context.dispatch("showUsername"),
          display_name: context.getters.getDisplayName,
          comment: comment
        };
        let res = await inquiry.send(params);
        return res;
      } catch (error) {
        console.log(error);
      }
    }
  },
  getters: {}
};
